import { render } from "./TotalMensalPrevistoGarantePayView.vue?vue&type=template&id=0053068a&scoped=true"
import script from "./TotalMensalPrevistoGarantePayView.vue?vue&type=script&lang=js"
export * from "./TotalMensalPrevistoGarantePayView.vue?vue&type=script&lang=js"

import "./TotalMensalPrevistoGarantePayView.vue?vue&type=style&index=0&id=0053068a&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0053068a"]])

export default __exports__